import styled from '@emotion/styled/macro';
import { rem, minWidth, Flex } from '@feast-it/pesto';

export const Placeholder = styled.span`
  color: ${({ theme }) => theme.colors.placeholderText};
`;

export const Input = styled(Flex)`
  align-items: center;
  background-color: ${({ theme }) => theme.colors.white};
  width: ${rem(400)};
  border: ${rem(1)} solid ${({ theme }) => theme.colors.blueLight};
  border-radius: ${rem(32)};
  px: ${rem(11)};
  font-family: ${({ theme }) => theme.fonts.body};
  color: ${({ theme }) => theme.colors.black};
  font-size: ${rem(16)};
  line-height: ${rem(22)};
  position: relative;
  z-index: 2;
  cursor: pointer;

  ${({ hasError }) =>
    hasError && `border-color: ${({ theme }) => theme.colors.red}`}

  &:after {
    display: none;
  }

  &:focus,
  &:active {
    border-color: ${({ theme }) => theme.colors.primary};
  }

  ${({ theme }) => minWidth(theme.breakpoints.m)} {
    padding: ${rem(20)};
    font-size: ${rem(18)};
    line-height: ${rem(24)};
  }
`;
